import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center text-body-2" }

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PosPage',
  setup(__props) {

const router = useRouter();

const navItems = [
  { name: 'appointments', icon: 'mdi-pencil-box', component: 'pos', route: 'appointments' },
  { name: 'Client Check In', icon: 'mdi-pencil-box', component: 'orders', route: 'client-checkin' },
  { name: 'Wait List', icon: 'mdi-pencil-box', component: 'orders', route: 'wait_list' },
  { name: 'Second screen', icon: 'mdi-file-document-multiple', component: '', route: 'appointment-second-screen' },
  { name: 'Daily Denomination', icon: 'mdi-file-document-multiple', component: '', route: 'daily-denomination' },
  { name: 'Sales Summary', icon: 'mdi-file-document-multiple', component: '', route: 'sales-summary' },
  { name: 'Cashout', icon: 'mdi-file-document-multiple', component: '', route: 'staff-checkout' },
  { name: 'Setup Terminal', icon: 'mdi-file-document-multiple', component: '', route: 'terminal-stripe' },
  { name: 'Settings', icon: 'mdi-cog', component: '', route: 'settings' },
  { name: 'Message', icon: 'mdi-file-document-multiple', component: 'message', route: 'messages' },
];

function navigateTo(route: string) {
  router.push({ name: route });
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("h1", { class: "text-h4 mb-6" }, "Point of Sale", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
            return _createVNode(_component_v_col, {
              key: item.route,
              cols: "12",
              sm: "6",
              md: "4",
              lg: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "nav-card",
                  hover: "",
                  onClick: ($event: any) => (navigateTo(item.route)),
                  height: "120"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "d-flex flex-column align-center justify-center h-100" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: item.icon,
                          size: "32",
                          class: "mb-2",
                          color: "primary"
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_1, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})